module.exports = __webpack_public_path__ + "static/img/u87.73c5f20e.png";